import Rutas from "../src/routes/Rutas";
import './App.css';
import "../src/styles/global.css"

function App() {
  return (
    <div className="App">
     <Rutas/>
    </div>
  );
}

export default App;
